module.exports = __webpack_public_path__ + "static/img/GogoOnGobg.7ba5723.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/GogoOnGobg.svg
// module id = 1144
// module chunks = 1